import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';

const API_BASE = process.env.REACT_APP_API_URL;

export default function BuildOrderDetails() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/build-orders/${id}`)
      .then(res => res.json())
      .then(setOrder)
      .catch(() => {});
  }, [id]);

  if (!order)
    return (
      <div className="ni-page">
        <div className="ni-shell ni-shell--narrow">
          <div className="ni-panel" style={loadingStyle}>
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );

  const deviceList = order.devices || order.items || [];

  const toggleCheck = async sn => {
    const dev = deviceList.find(d => d.serialNumber === sn);
    if (!dev) return;
    await fetch(`${API_BASE}/device/${sn}/received`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ received: !dev.received })
    });
    setOrder(o => {
      const devices = o.devices.map(d =>
        d.serialNumber === sn ? { ...d, received: !dev.received } : d
      );
      const all = devices.every(d => d.received);
      return { ...o, devices, status: all ? 'Completed' : o.status };
    });
  };
  const acknowledge = async () => {
    await fetch(`${API_BASE}/build-orders/${id}/acknowledge`, { method: 'POST' });
    navigate('/build-orders');
  };

  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <div className="ni-panel">
          <div className="ni-section-heading" style={{ marginBottom: '1rem' }}>
            <div>
              <h2 className="ni-section-title">Order {order.orderNumber}</h2>
              <p className="ni-section-copy">Product: {order.product}</p>
              {order.dueDate && (
                <p className="ni-note" style={{ marginTop: '0.35rem' }}>Ready by: {new Date(order.dueDate).toLocaleDateString()}</p>
              )}
            </div>
            <span className="ni-pill">{order.status}</span>
          </div>
          <div className="ni-table-wrap">
            <table className="ni-table">
              <thead>
                <tr>
                  <th>Serial Number</th>
                  <th>Progress</th>
                  {order.status === 'In Transit' && <th>Received</th>}
                </tr>
              </thead>
              <tbody>
                {deviceList.map((it, idx) => (
                  <tr
                    key={idx}
                    onClick={() => navigate(`/build-device/${it._id || it.serialNumber}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{it.serialNumber}</td>
                    <td>
                      {it.progress
                        ? `Subassy1: ${it.progress.subassy1} | Test: ${it.progress.test}`
                        : 'N/A'}
                    </td>
                    {order.status === 'In Transit' && (
                      <td>
                        <input
                          type="checkbox"
                          checked={!!it.received}
                          onChange={() => toggleCheck(it.serialNumber)}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {order.status === 'Completed' && (
            <button
              onClick={acknowledge}
              className="ni-button ni-button--primary"
              style={{ marginTop: '1rem' }}
            >
              Acknowledge Receipt
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const loadingStyle = {
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

